import { Textarea } from "../ui/textarea";
import { LogoUploader } from "./LogoUploader";
import type { TimelineEvent } from "./MilestoneEditForm";

interface MilestoneFormFieldsProps {
  editingEvent: Partial<TimelineEvent>;
  setEditingEvent: React.Dispatch<React.SetStateAction<Partial<TimelineEvent> | null>>;
}

export function MilestoneFormFields({ editingEvent, setEditingEvent }: MilestoneFormFieldsProps) {
  const updateField = (key: keyof TimelineEvent, val: string) => {
    setEditingEvent((p: any) => ({ ...p!, [key]: val }));
  };

  return (
    <div className="overflow-x-auto border border-border/60 rounded-xl bg-card/30">
      <table className="min-w-full divide-y divide-border/40 text-sm">
        <thead className="bg-muted/40 font-semibold text-brand-secondary">
          <tr>
            <th className="px-4 py-2.5 text-left w-1/4 border-r border-border/40 text-xs uppercase tracking-wider">Field</th>
            <th className="px-4 py-2.5 text-left w-3/8 border-r border-border/40 text-xs uppercase tracking-wider">English (EN)</th>
            <th className="px-4 py-2.5 text-left w-3/8 text-xs uppercase tracking-wider">Turkish (TR)</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border/40">
          <tr className="hover:bg-muted/10 transition-colors">
            <td className="px-4 py-3 font-medium border-r border-border/40 align-middle">Company/Org Name</td>
            <td className="px-3 py-2 border-r border-border/40">
              <Textarea
                value={editingEvent.company_en || ""}
                onChange={(e) => updateField("company_en", e.target.value)}
                className="w-full bg-background/50 border-border/30 focus-visible:ring-1 focus-visible:ring-brand-primary h-9 min-h-[36px] resize-y py-1.5 text-xs"
                placeholder="e.g. Reida Prints Shop"
              />
            </td>
            <td className="px-3 py-2">
              <Textarea
                value={editingEvent.company_tr || ""}
                onChange={(e) => updateField("company_tr", e.target.value)}
                className="w-full bg-background/50 border-border/30 focus-visible:ring-1 focus-visible:ring-brand-primary h-9 min-h-[36px] resize-y py-1.5 text-xs"
                placeholder="örn. Reida Prints Shop"
              />
            </td>
          </tr>
          <tr className="hover:bg-muted/10 transition-colors">
            <td className="px-4 py-3 font-medium border-r border-border/40 align-middle">Role/Degree Title</td>
            <td className="px-3 py-2 border-r border-border/40">
              <Textarea
                value={editingEvent.role_en || ""}
                onChange={(e) => updateField("role_en", e.target.value)}
                className="w-full bg-background/50 border-border/30 focus-visible:ring-1 focus-visible:ring-brand-primary h-9 min-h-[36px] resize-y py-1.5 text-xs"
                placeholder="e.g. Founder"
              />
            </td>
            <td className="px-3 py-2">
              <Textarea
                value={editingEvent.role_tr || ""}
                onChange={(e) => updateField("role_tr", e.target.value)}
                className="w-full bg-background/50 border-border/30 focus-visible:ring-1 focus-visible:ring-brand-primary h-9 min-h-[36px] resize-y py-1.5 text-xs"
                placeholder="örn. Kurucu"
              />
            </td>
          </tr>
          <tr className="hover:bg-muted/10 transition-colors">
            <td className="px-4 py-3 font-medium border-r border-border/40 align-middle">Duration</td>
            <td className="px-3 py-2 border-r border-border/40">
              <Textarea
                value={editingEvent.duration_en || ""}
                onChange={(e) => updateField("duration_en", e.target.value)}
                className="w-full bg-background/50 border-border/30 focus-visible:ring-1 focus-visible:ring-brand-primary h-9 min-h-[36px] resize-y py-1.5 text-xs"
                placeholder="e.g. 2026 - Still"
              />
            </td>
            <td className="px-3 py-2">
              <Textarea
                value={editingEvent.duration_tr || ""}
                onChange={(e) => updateField("duration_tr", e.target.value)}
                className="w-full bg-background/50 border-border/30 focus-visible:ring-1 focus-visible:ring-brand-primary h-9 min-h-[36px] resize-y py-1.5 text-xs"
                placeholder="örn. 2026 - Devam Ediyor"
              />
            </td>
          </tr>
          <tr className="hover:bg-muted/10 transition-colors">
            <td className="px-4 py-3 font-medium border-r border-border/40 align-middle">Year (e.g. 2026)</td>
            <td colSpan={2} className="px-3 py-2">
              <Textarea
                value={editingEvent.year || ""}
                onChange={(e) => updateField("year", e.target.value)}
                className="w-full max-w-[280px] bg-background/50 border-border/30 focus-visible:ring-1 focus-visible:ring-brand-primary h-9 min-h-[36px] resize-y py-1.5 text-xs"
                placeholder="e.g. 2026"
              />
            </td>
          </tr>
          <tr className="hover:bg-muted/10 transition-colors">
            <td className="px-4 py-3 font-medium border-r border-border/40 align-middle">Company/Org Logo</td>
            <td colSpan={2} className="px-3 py-2">
              <LogoUploader
                logoUrl={editingEvent.logo_url}
                onChange={(base64) => setEditingEvent((prev: any) => ({ ...prev!, logo_url: base64 }))}
                onRemove={() => setEditingEvent((p: any) => ({ ...p!, logo_url: "" }))}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
